/**
 * Current frontend hostname extracted from browser location.
 */
const currentHost = window.location.hostname;

/**
 * Per-hostname Azure AD fallback configuration.
 *
 * These values are used when the CI/CD pipeline does not provide
 * REACT_APP_* values for the target environment.
 *
 * DEV and UAT are currently enabled in the CI/CD pipeline.
 * Production deployment is currently disabled.
 *
 * Client IDs and tenant IDs are public identifiers, not credentials.
 * They are normally visible in the browser bundle.
 */
const azureAdMap: Record<string, { clientId: string; tenantUrl: string }> = {
  // LOCAL
  'localhost': {
    clientId: '98dc6f71-84c5-49bb-a9c8-43e39f30406d',
    tenantUrl:
      'https://login.microsoftonline.com/cd62b7dd-4b48-44bd-90e7-e143a22c8ead',
  },

  // DEV
  'cilantro3-dev-frontend-bvhwc9hvavhsa6cs.centralindia-01.azurewebsites.net': {
    clientId: '98dc6f71-84c5-49bb-a9c8-43e39f30406d',
    tenantUrl:
      'https://login.microsoftonline.com/cd62b7dd-4b48-44bd-90e7-e143a22c8ead',
  },

  // UAT
  'cilantrouat.mycompass.co.in': {
    clientId: '98dc6f71-84c5-49bb-a9c8-43e39f30406d',
    tenantUrl:
      'https://login.microsoftonline.com/cd62b7dd-4b48-44bd-90e7-e143a22c8ead',
  },

  'cilantrouat-cr-appservices-frontend-ajccekcedzefevfq.centralindia-01.azurewebsites.net':
    {
      clientId: '98dc6f71-84c5-49bb-a9c8-43e39f30406d',
      tenantUrl:
        'https://login.microsoftonline.com/cd62b7dd-4b48-44bd-90e7-e143a22c8ead',
    },

  // PROD
  'cilantro.mycompass.co.in': {
    clientId: '2df7f642-791c-4f9b-bbec-c01ff38e3693',
    tenantUrl:
      'https://login.microsoftonline.com/cd62b7dd-4b48-44bd-90e7-e143a22c8ead',
  },
};

/**
 * Resolve Azure AD configuration from the current hostname.
 *
 * An unknown hostname is treated as an error rather than
 * falling back to another environment.
 */
const azureAd = Object.entries(azureAdMap).find(([host]) => currentHost.includes(host))?.[1];

if (!azureAd) {
  throw new Error(
    `No Azure AD configuration found for hostname "${currentHost}".`
  );
}

/**
 * GitHub Actions REACT_APP_* values take priority over
 * hostname-based fallback configuration.
 */
export const AZURE_AD_CLIENT_ID: string =
  process.env.REACT_APP_AZURE_AD_CLIENT_ID || azureAd.clientId;

export const TENANT_URL: string =
  process.env.REACT_APP_TENANT_URL || azureAd.tenantUrl;

export const API_BASE_URL: string =
  process.env.REACT_APP_AZURE_APP_BASE_URL || '';

/**
 * Final configuration validation.
 */
if (!AZURE_AD_CLIENT_ID || !TENANT_URL) {
  throw new Error(
    `Missing Azure AD configuration for host "${currentHost}".`
  );
}

// Not in use DEV
// export const AZURE_AD_CLIENT_ID = 'd85e9419-806b-4c35-9f62-d5fff7a75b89';
// export const TENANT_URL = 'https://login.microsoftonline.com/4f80b5dd-0f05-4843-be6d-e6544e03660a';

// DEV
//   export const AZURE_AD_CLIENT_ID = '98dc6f71-84c5-49bb-a9c8-43e39f30406d';
//   export const TENANT_URL = 'https://login.microsoftonline.com/cd62b7dd-4b48-44bd-90e7-e143a22c8ead';

// QA
// export const AZURE_AD_CLIENT_ID = '98dc6f71-84c5-49bb-a9c8-43e39f30406d';
// export const TENANT_URL = 'https://login.microsoftonline.com/cd62b7dd-4b48-44bd-90e7-e143a22c8ead';

// UAT
// export const AZURE_AD_CLIENT_ID = '98dc6f71-84c5-49bb-a9c8-43e39f30406d';
// export const TENANT_URL = 'https://login.microsoftonline.com/cd62b7dd-4b48-44bd-90e7-e143a22c8ead';

// prod
// export const AZURE_AD_CLIENT_ID = '2df7f642-791c-4f9b-bbec-c01ff38e3693';
// export const TENANT_URL = 'https://login.microsoftonline.com/cd62b7dd-4b48-44bd-90e7-e143a22c8ead';
